<template>
  <span class="children-c">
    <h3 class="abs logo">Invoice<span>ystem</span></h3>
    <div class="login-form" :class="{ isMounted: mounted }">
      <div
        class="left-side"
        :style="{ 'background-image': `url(${loginSide})` }"
      >
        <div
          class="profile-image"
          :style="{ 'background-image': `url(${userImage})` }"
        />
      </div>
      <div class="right-side">
        <h4 class="right pt-15">
          <font-awesome-icon icon="user" /> User login
        </h4>
        <p class="message" :class="{ error: error, hasMessage: message }">
          {{ message }}
        </p>
        <label>Username</label>
        <input
          type="text"
          :value="username"
          placeholder="username"
          :disabled="loading"
          @input="e => updateField('username', e.target.value)"
        />
        <label>Password</label>
        <input
          type="password"
          :value="password"
          placeholder="password"
          :disabled="loading"
          @input="e => updateField('password', e.target.value)"
        />
        <div>
          <button class="green" @click="loginUser" :disabled="loading">
            Submit
          </button>
        </div>
      </div>
    </div>
    <p class="abs version">{{ version }}</p>
  </span>
</template>

<script>
import userImage from "../assets/userImage.png";
import loginSide from "../assets/login-side.png";
export default {
  name: "LoginForm",
  props: ["version"],
  data: () => ({
    mounted: false,
    userImage,
    loginSide,
    loading: false,
    error: false,
    message: null,
    username: "",
    password: ""
  }),
  mounted: function() {
    document.addEventListener('keypress', this.onKeyPress)
    setTimeout(() => (this.mounted = true), 0);
  },
  destroyed () {
    document.removeEventListener('keypress', this.onKeyPress)
  },
  methods: {
    onKeyPress(e) {
      e.keyCode === 13
        && this.username !== '' && this.password !== '' && this.loginUser()
    },
    updateField(field, value) {
      this[field] = value;
    },
    loginUser() {
      this.error = false;
      this.loading = true;
      this.message = "Logging in...";
      this.$store
        .dispatch("userLogin", {
          username: this.username,
          password: this.password
        })
        .then(result => {
          const mobile = window.innerWidth <= 950;
          if (mobile && !this.isMobile) {
            this.$store.commit("updateIsMobile", true);
          }
          if (!mobile && this.isMobile) {
            this.$store.commit("updateIsMobile", false);
          }
          this.loading = false;
          if (result === "success") {
            this.message = null;
          } else {
            this.message = "Error logging in. Please try again";
            this.error = true;
          }
        });
    }
  }
};
</script>

<style lang="scss">
@import "../styles/colors.scss";
.children-c {
  height: 100vh;
  .abs {
    width: 100%;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 10px;
    left: 0;
    text-align: center;
    &.version {
      top: auto;
      bottom: 10px;
      color: rgb(185, 70, 70);
    }
    &.logo {
      color: #fff;
      font-size: 1.65rem;
      padding: 0;
      margin: 0;
      & span {
        font-size: 1.65rem;
        color: $green;
      }
    }
  }
  & .login-form {
    box-shadow: 0 0 13px rgb(77, 0, 0);
    display: flex;
    position: relative;
    top: 100px;
    opacity: 0;
    background-color: #fff;
    max-width: 600px;
    width: 90%;
    border-radius: 5px;
    transition: top 0.5s, opacity 0.5s;
    & .left-side {
      border-radius: 5px;
      width: 28%;
      background-color: #9b9b9b;
      background-size: 100%;
      background-position: -78px -20px;
    }
    & .right-side {
      width: calc(100% - 28%);
      & > * {
        width: 90%;
        margin: 0 auto;
        display: block;
      }
      h4 {
        color: $darkBlue;
        margin-top: 10px;
        svg {
          margin-right: 5px;
          top: -1px;
          position: relative;
        }
      }
      label {
        font-size: 1.2rem;
        margin: 28px auto 14px auto;
        color: #333;
        display: block;
      }
      .message {
        height: 0;
        margin: 0;
        opacity: 0;
        text-align: center;
        transition: opacity 0.4s;
        background-color: $lightBlue;
        box-shadow: 0 0 0 1px $darkBlue;
        color: #fff;
        border-radius: 4px;
        &.error {
          background-color: red;
          box-shadow: 0 0 0 1px red;
        }
        &.hasMessage {
          padding: 5px 0 5px 0;
          margin: 0 auto;
          margin-top: 20px;
          opacity: 1;
          height: auto;
        }
      }
      input[type="text"],
      input[type="password"] {
        box-shadow: 0 0 0 1px rgb(117, 197, 228);
        padding: 13px 10px;
        border-radius: 4px;
        background-color: rgb(240, 251, 255);
        width: calc(90% - 20px);
        transition: all 0.5s;
        &:focus {
          background-color: rgb(217, 243, 252);
          box-shadow: 0 0 0 1px rgb(41, 155, 201);
        }
        &:disabled {
          background-color: rgb(221, 221, 221);
          box-shadow: 0 0 0 1px gray;
        }
      }
      & > div {
        text-align: right;
        button {
          padding: 10px 15px;
          margin: 30px auto 20px auto;
        }
      }
    }

    &.isMounted {
      top: 0px;
      opacity: 1;
    }

    @media screen and (max-width: 500px) {
      flex-direction: column;
      & .left-side,
      & .right-side {
        width: 100%;
        h4 {
          padding-top: 20px;
        }
      }
      & .left-side {
        height: 20px;
        .profile-image {
          margin-left: 27px;
        }
      }
    }
  }
  .profile-image {
    margin: -60px auto auto auto;
    border-radius: 50%;
    width: 110px;
    height: 110px;
    background-color: lightblue;
    border: 9px solid #fff;
    background-position: center;
    background-size: contain;
    box-shadow: 0 0 3px rgb(83, 83, 83);
  }
}
</style>
